export enum FormActionType {
	ADD = 'ADD',
	GET = 'GET',
	REMOVE = 'REMOVE',
	UPDATE = 'UPDATE',
	NONE = 'NONE',
}
